export class Agent {
  agentId
  name
  email
  phone
  calenderURL

  constructor(agent = {}) {
    this.agentId = agent.agentId ? String(agent.agentId) : ''
    this.name = agent.name ? String(agent.name) : ''
    this.email = agent.email ? String(agent.email) : ''
    this.phone = agent.phone ? String(agent.phone) : ''
    this.calenderURL = agent.calenderURL ? String(agent.calenderURL) : ''
  }
}